import { AfterViewInit, Component, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from 'src/app/core/services/login.service';
import { SettingsService } from 'src/app/core/services/settings.service';
import { EntityService } from 'src/app/core/services/entity.service';
import { Entity } from 'src/app/core/models/entity.model';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import * as utils from 'src/app/shared/helpers/utils';
import { DdbbUtils } from 'src/app/shared/helpers/utils';
import { User } from 'src/app/core/models/user.model';
import { ConfigService } from 'src/app/core/services/config.service';
import { Groups } from 'src/app/core/models/group.model';

declare var bootstrap: any; // Required for Bootstrap 5

@Component({
  selector: 'hbo-setting-list',
  templateUrl: './setting-list.component.html',
  styleUrls: ['./setting-list.component.scss']
})
export class SettingListComponent implements AfterViewInit {

  groups: Groups = new Groups;

  @HostListener('document:shown.bs.collapse', ['$event'])
  onAccordionOpen(event: any) {
    this.openedRow = event.target!.id;
    const entityId = Number((<HTMLElement>event.target).id.split('-')[1]);
    this.configSvc.setConfigPaginationParamValue('settings', 'entityId', entityId);
    this.settingsFocused = this.configSvc.currentConfigValue.paginations!['settings']!.settingsTab![entityId];
    if (this.user.id === entityId && this.user.roleId === 1) {
      //admin role allways has access to every type of info about an app
      const appsIds = Object.values(this.groups).flat();//get all apps ids
      this.entityApps = appsIds;
      // Same "admin sees everything" fiction as above, so the dashboard blocks keep showing
      this.standaloneAppsIds = appsIds;
      this.configSvc.setConfigAppsValue('settings', this.configSvc.currentConfigValue.paginations!['settings'].entityId!, appsIds);
    } else {
      this.entityService.getEntityApps(entityId).subscribe(res => {
        this.entityApps = res.appsIds;
        this.standaloneAppsIds = res.standaloneAppsIds ?? [];
        this.configSvc.setConfigAppsValue('settings', this.configSvc.currentConfigValue.paginations!['settings'].entityId!, res.appsIds);
      });
    }
  }

  @HostListener('document:hide.bs.collapse', ['$event'])
  onAccordionClosed(event: Event) {
    this.openedRow = null;
    this.entityApps = [];
    this.standaloneAppsIds = [];
    this.settingsService.settingsStore.next(this.configSvc.currentConfigValue.userSettings);
  }



  settingsFocused!: string | null;
  entityId!: number;

  entities$ = new Observable<Pagination<Entity>>;
  user: User = utils?.localStorageGetItem('user');

  openedRow!: string | null;

  public entityApps: number[] = [];
  // Kept apart from entityApps: the settings tabs gate on "has the app at all", while the
  // dashboard card blocks gate on "has it as a standalone package".
  public standaloneAppsIds: number[] = [];

  constructor(
    private location: Location,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public settingsService: SettingsService,
    public entityService: EntityService,
    public loginService: LoginService,
    private configSvc: ConfigService
  ) { }

  ngAfterViewInit() {
    const storageSettingsFilter = localStorage.getItem('settingsListFilter');
    if (storageSettingsFilter) {
      this.searchEntities(JSON.parse(storageSettingsFilter));
    } else {
      this.searchEntities(this.configSvc.currentConfigValue.paginations ? this.configSvc.currentConfigValue.paginations['settings']?.pagination : null);
    }
  }

  setFocusedSettings = (_focus: string | null, _entityId: number) => {
    this.settingsFocused = _focus;
    this.entityId = _entityId;
    this.configSvc.setConfigPaginationParamValue('settings', 'entityId', this.entityId);
    this.configSvc.currentConfigValue.paginations!['settings']!.settingsTab![this.configSvc.currentConfigValue.paginations!['settings'].entityId!] = _focus;
    this.location.replaceState(`settings/${_focus}`);
  }

  searchEntities = (pagination?: PaginationRequest | null) => {

    this.openedRow = null;
    let entities: string | null = null;
    if (this.configSvc.currentConfigValue.settingsListSelected?.length) {
      entities = `${this.configSvc.currentConfigValue.settingsListSelected?.map((entity: Entity) => entity.id).join(',')}`;
    }
    if (pagination) pagination!.entities = entities;

    this.entities$ = this.entityService.index(pagination ?? { order: 'desc', entities: entities });
    this.configSvc.setConfigPaginationParamValue('settings', 'entities', this.entities$);
  }

  onAccordionClose = (event: Event) => { }

  get teams() {
    return this.configSvc.currentConfigValue.teams ?? [];
  }

  open = (entityId: number) => {
    // esperar a que termine la animación collapsing para saber si está abierto o cerrado
    setTimeout(() => {
      if (this.isOpen(entityId)) { }
    }, 400);
  }

  isOpen = (entityId: number, appId?: number): boolean => {
    if (this.configSvc.currentConfigValue.paginations!['settings'].entityId === entityId) {
      return true
    } else {
      return false
    }
  }

  setApps = (e: any) => {
    this.setFocusedSettings(null, this.configSvc.currentConfigValue.paginations!['settings'].entityId!);
    this.entityService.getEntityApps(this.configSvc.currentConfigValue.paginations!['settings'].entityId!).subscribe(res => {
      this.entityApps = res.appsIds;
      this.standaloneAppsIds = res.standaloneAppsIds ?? [];
      this.configSvc.setConfigAppsValue('settings', this.configSvc.currentConfigValue.paginations!['settings'].entityId!, res.appsIds)
    });
  }
}
